// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__d78XZ","col":"Table_col__QOClH","fulfillmentStatus":"Table_fulfillmentStatus__3YA5f","emailCol":"Table_emailCol__2wGw8"};